<template>
  <div class="">
    <div class="detail-store-based-marketing-title">
      <CustomBreadcrumb/>
    </div>
    <div class="detail-title">{{campaignName}}</div>
    <div class="detail-tabs">
      <el-tabs v-model="selectedTab" @tab-click="handleClick">
        <el-tab-pane :label="'Open Rate ('+openRatePercent+')'" name="openRate"><OpenRate ref="openRate"/></el-tab-pane>
        <el-tab-pane :label="'Click Rate ('+clickRatePercent+')'" name="clickRate"><ClickRate ref="clickRate"/></el-tab-pane>
        <el-tab-pane :label="'View Product ('+viewProductPercent+')'" name="viewProduct"><ViewProduct ref="viewProduct"/></el-tab-pane>
        <el-tab-pane :label="'Add to cart ('+addToCartPercent+')'" name="addToCart"><AddToCart ref="addToCart"/></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomBreadcrumb from '../components/custom-breadcrumb'
import AddToCart from './store-based-marketing-detail/add-to-cart.vue'
import ClickRate from './store-based-marketing-detail/click-rate.vue'
import OpenRate from './store-based-marketing-detail/open-rate.vue'
import ViewProduct from './store-based-marketing-detail/view-product.vue'

export default {
  components: {
    CustomBreadcrumb,
    OpenRate,
    ClickRate,
    ViewProduct,
    AddToCart
  },
  data() {
    return {
      campaignName: this.$route.query.campaignName,
      openRatePercent: this.$route.query.openRatePercent,
      clickRatePercent: this.$route.query.clickRatePercent,
      viewProductPercent: this.$route.query.viewProduct,
      addToCartPercent: this.$route.query.addToCart,
      selectedTab: this.$route.query.selectedTab,
      marketingId: this.$route.query.marketingId,
      marketingBatch: this.$route.query.marketingBatch
    }
  },
  created() {
    // 进来要根据传来的selectedTab 进行初始化数据
    this.$nextTick(() => {
      this.$refs[this.selectedTab].init(this.marketingId, this.marketingBatch)
    })
  },
  methods: {
    // 切换tab初始化数据
    handleClick(tab, event) {
      this.$refs[tab.name].init(this.marketingId, this.marketingBatch)
    }
  }
}
</script>

<style lang="less" scoped>
.detail-store-based-marketing-title {
  font-size: 14px;
  font-weight: 600;
  color: #262B2F;
  margin: 10px 0px 20px 0px !important;
}
.detail-title{
  font-size: 18px;
  font-family: Satoshi-Bold !important;
  color: #000000;
}
.detail-tabs{
  margin-top: 22px;
}
/deep/ .el-tabs__nav-wrap:after{
  background-color: #E1E1E1 !important;
}
/deep/ .el-tabs__active-bar{
  background-color: #262B2F;
}
/deep/ .el-tabs__item.is-active{
  color: #262B2F !important;
  font-family: Satoshi-Medium !important;
  font-size: 14px !important;
}
/deep/ .el-tabs__item:hover{
  color: #262B2F !important;
  font-family: Satoshi-Medium !important;
}
/deep/ .el-tabs__active-bar{
  background-color: #262B2F !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/store-based-marketing/store-based-marketing-detail.vue